import * as req from 'api/actions';
import * as c from './constant';

export const getList = (buildingId, payload, callback) =>
  req.list(
    c.GET_LIST,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas?isPaginate=1`,
    payload,
    callback
  );

export const showData = (buildingId, id, payload, callback) =>
  req.item(
    c.SHOW_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas/${id}`,
    payload,
    callback
  );

export const createData = (buildingId, payload, callback) =>
  req.create(
    c.CREATE_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateData = (buildingId, payload, callback) =>
  req.update(
    c.UPDATE_DATA,
    `api/v1/rpt/administrator/buildings/building_applications/${buildingId}/building_floor_storey_areas`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

  export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USE_LIST,
    'api/v1/rpt/administrator/settings/actual_uses?status=1',
    payload,
    callback
  );